import script from "./Banners.vue?vue&type=script&setup=true&lang=js"
export * from "./Banners.vue?vue&type=script&setup=true&lang=js"

import "./Banners.vue?vue&type=style&index=0&id=dc317060&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/duanju-overseas_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc317060"]])

export default __exports__